import notSet from './notSet';

export default (val, field) => {
    if (notSet(val)) {
        return null;
    }
    switch (field) {
        case 'hours':
        case 'minutes':
        case 'seconds': {
            if (!/^[0-9]{1,}$/.test(val)) {
                return 'Please provide your finish time';
            }
            break;
        }
        default:
    }

    return null;
};



/** WEBPACK FOOTER **
 ** ./src/utils/signupRaceValidator.js
 **/